import { render } from "./DealDetail.vue?vue&type=template&id=8dab925c&scoped=true"
import script from "./DealDetail.vue?vue&type=script&lang=js"
export * from "./DealDetail.vue?vue&type=script&lang=js"

import "./DealDetail.vue?vue&type=style&index=0&id=8dab925c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dab925c"]])

export default __exports__